module.exports = __webpack_public_path__ + "static/media/eyeLotion1.8a38ced5.jpg";